export default "__VITE_ASSET__CmAvaKyx__"